/**
 * returns the format "{n}d {n}h {n}m {n}s" where the values are greater than 0
 */
export const useNarrowCountdownFormat = (timeLeft: Ref<Countdown | "">) => {
  const { t } = useI18n();

  return computed(() => {
    if (!timeLeft.value) {
      return timeLeft;
    }

    const days = t("product.timeLeft.days", {
      PLACEHOLDER_n: timeLeft.value.days,
    });
    const hours = t("product.timeLeft.hours", {
      PLACEHOLDER_n: timeLeft.value.hours,
    });
    const minutes = t("product.timeLeft.minutes", {
      PLACEHOLDER_n: timeLeft.value.minutes,
    });
    const seconds = t("product.timeLeft.seconds", {
      PLACEHOLDER_n: timeLeft.value.seconds,
    });

    if (timeLeft.value.days > 0) {
      return `${days} ${hours} ${minutes} ${seconds}`;
    }

    if (timeLeft.value.hours > 0) {
      return `${hours} ${minutes} ${seconds}`;
    }

    if (timeLeft.value.minutes > 0) {
      return `${minutes} ${seconds}`;
    }

    return seconds;
  });
};
